import { Modal } from "flowbite-react"
import FormRegisterProduct from "../form/FormRegisterProduct"

type Props = {
    onClose: () => void;
    onSave: (productId: string) => void;
};

export default function ModalRegisterProduct(props: Props) {
    const handleCloseModal = () => { props.onClose && props.onClose() }

    return (
        <Modal
            className="relative text-black"
            show={true}
            size="5xl"
            onClose={handleCloseModal}
        >
            <Modal.Header>
                <h2 className="text-black text-lg md:text-xl lg:text-2xl">Cadastrar Produto</h2>
            </Modal.Header>
            <Modal.Body className="text-black dark:text-black p-2 sm:p-4 md:p-6 lg:p-8">
                <div>
                    <FormRegisterProduct onSubmit={handleCloseModal} />
                </div>
            </Modal.Body>
        </Modal>
    )
}